import { Translatable } from '@app/types/translatable.type';

export const HiringAccessLevelLabelOptions: { [key: string]: Translatable } = {
    Recruiter: 'applicant-tracker.recruiter',
    'Hiring Manager': 'applicant-tracker.hiringManager',
    Basic: 'applicant-tracker.basic',
    'Only Recruiters': 'applicant-tracker.onlyRecruiters',
    'Only Recruiters & Hiring Managers': 'applicant-tracker.onlyRecruitersAndHiringManagers',
    'Everyone on the Hiring Team': 'applicant-tracker.everyoneOnTheHiringTeam',
};
